import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NotificationEntity } from 'src/app/models/entities/notification.entity';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { PriorityItemsComponent } from '../priority-items/priority-items.component';
import { CardActionsComponent } from '../card-actions/card-actions.component';
import { AvatarModule } from '../avatar/avatar.module';
import { NotificationService } from 'src/app/services/api/notifications.service';
import { UserService } from 'src/app/services/api/user.service';
import { MatButtonModule } from '@angular/material/button';
import { DirectivesModule } from 'src/app/directives/directives.modules';

@Component({
    selector: 'app-notifications',
    imports: [CommonModule, DirectivesModule, MatButtonModule, AvatarModule, MatIconModule, PipesModule, CardActionsComponent],
    templateUrl: './notifications.component.html',
    styleUrl: './notifications.component.scss'
})
export class NotificationsComponent {

  notifications: NotificationEntity[] = [];
  @Output() deleteNotification = new EventEmitter<NotificationEntity>();

  constructor(
    public notificationController: NotificationService,
    public userService: UserService,
    public dialogRef: MatDialogRef<PriorityItemsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.notifications) {
      this.notifications = data.notifications;
    }
  }

  getClientName(client: any): string {
    if (!client) {
      return 'Unknown Client';
    }
    
    if (typeof client === 'string') {
      return client || 'Unknown Client';
    }
    
    if (typeof client === 'object' && client.name) {
      return client.name;
    }
    
    return 'Unknown Client';
  }

  delete(notification: NotificationEntity): void {
    this.userService.currentUser$.subscribe(user => {
      this.notificationController.deleteItem(user.key, notification);

      this.notifications = this.notifications.filter(n => n.key !== notification.key);

    });
  }
  clearAll(): void {
    this.userService.currentUser$.subscribe(user => {
      this.notifications.forEach(notification => {
        this.notificationController.deleteItem(user.key, notification);
      });
      this.notifications = [];
    });
  }
  navigate(notification: NotificationEntity): void {
    this.dialogRef.close({ nav: notification });
  }
  close(): void {
    this.dialogRef.close();
  }
}
